import { render, staticRenderFns } from "./LifeInfo.vue?vue&type=template&id=113f3d55&scoped=true"
import script from "./LifeInfo.vue?vue&type=script&lang=js"
export * from "./LifeInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113f3d55",
  null
  
)

export default component.exports